export default "__VITE_ASSET__f914edfa__"